import {
  InvoiceReportOrderByDirection,
  InvoiceReportOrderByField,
} from 'ap-openapi';

// Sort field types - common across invoice report pages
export type SortField =
  | 'number'
  | 'created_at'
  | 'submitted_at'
  | 'book_date'
  | 'due_date'
  | 'approved_at'
  | 'payment_date';

export type SortOrder = 'ascend' | 'descend' | undefined;

export type OrderByItem = {
  field: InvoiceReportOrderByField;
  direction: InvoiceReportOrderByDirection;
};

// Multi-column sort state
export interface MultiColumnSortState {
  columnKey: string;
  order: 'ascend' | 'descend';
}

// For validation of sort states from table component
// Note: order can be null when the table component clears sort
export interface SortOrderState {
  columnKey?: string;
  order?: 'ascend' | 'descend' | null;
}

// Sort field mapping - maps UI column keys to API field names
export const SORT_FIELD_MAPPING: Record<SortField, InvoiceReportOrderByField> =
  {
    number: 'number',
    created_at: 'created_date',
    submitted_at: 'submitted_date',
    book_date: 'invoice_book_date',
    due_date: 'invoice_due_date',
    approved_at: 'approved_date',
    payment_date: 'payment_date',
  };

// Reverse mapping for API to UI
export const API_TO_COLUMN_MAPPING: Record<string, string> = {
  created_date: 'created_at',
  submitted_date: 'submitted_at',
  invoice_due_date: 'due_date',
  invoice_book_date: 'book_date',
  approved_date: 'approved_at',
  payment_date: 'payment_date',
};

// Helper function to map column key to API sort field
export const mapColumnKeyToApiSortField = (
  field: SortField
): InvoiceReportOrderByField => {
  return SORT_FIELD_MAPPING[field];
};

// Helper function to map API sort field to column key
export const mapApiSortFieldToColumnKey = (
  apiField: InvoiceReportOrderByField | null
): string => {
  if (!apiField) return '';
  return API_TO_COLUMN_MAPPING[apiField] || apiField;
};

// Validate sort state from table component
export const isValidSortState = (
  state: SortOrderState
): state is MultiColumnSortState => {
  return (
    typeof state.columnKey === 'string' &&
    state.columnKey !== '' &&
    (state.order === 'ascend' || state.order === 'descend')
  );
};
